/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Fb_Toast_ArrivedInputs */

const en_fb_toast_arrived = /** @type {(inputs: Fb_Toast_ArrivedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} sent ${i?.count} points`)
};

const de_fb_toast_arrived = /** @type {(inputs: Fb_Toast_ArrivedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} hat ${i?.count} Punkte geschickt`)
};

/**
* | output |
* | --- |
* | "{name} sent {count} points" |
*
* @param {Fb_Toast_ArrivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fb_toast_arrived = /** @type {((inputs: Fb_Toast_ArrivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fb_Toast_ArrivedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fb_toast_arrived(inputs)
	return en_fb_toast_arrived(inputs)
});